import React, { Component } from 'react';
import { Link,
         withRouter,
} from 'react-router-dom';

import { auth, db } from '../../firebase';

import '../../global.css';
import './SignUp.css';

const SignUpPage = ({ history }) =>
    <div className="main">
        <div className="mostly-opaque-white">

        <SignUpForm history={history} />
        </div>
    </div>;

const INITIAL_STATE = {
    username: '',
    email: '',
    passwordOne: '',
    passwordTwo: '',
    error: null,
};

const byPropKey = (propertyName, value) => () => ({
    [propertyName]: value,
});

class SignUpForm extends Component {
    constructor(props) {
        super(props);

        this.state = { ...INITIAL_STATE };
    }

    onSubmit = (event) => {
        const {
            username,
            email,
            passwordOne,
        } = this.state;

        const {
            history,
        } = this.props;

        auth.doCreateUserWithEmailAndPassword(email, passwordOne)
            .then(authUser => {

                // Create a user in your own accessible Firebase Database too
                db.doCreateUser(authUser.user.uid, username, email)
                    .then(() => {

                        this.setState(() => ({ ...INITIAL_STATE }));
                        history.push('/home');
                    })
                    .catch(error => {
                        this.setState(byPropKey('error', error));
                    });
            })
            .catch(error => {
                this.setState(byPropKey('error', error));
            });

        event.preventDefault();
    };

    render() {
        const {
            username,
            email,
            passwordOne,
            passwordTwo,
            error,
        } = this.state;

        const isInvalid =
            passwordOne !== passwordTwo ||
            passwordOne === '' ||
            email === '' ||
            username === '';

        return (
            <form className = "form-signin" onSubmit={this.onSubmit}>
                <h2 className = "big-bottom-margin" >
                    SignUp
                </h2>
                <input
                    type="text"
                    value={username}
                    onChange={event => this.setState(byPropKey('username', event.target.value))}
                    placeholder="Pick Username"
                    className="form-control"
                />
                <input
                    type="email"
                    value={email}
                    onChange={event => this.setState(byPropKey('email', event.target.value))}
                    placeholder="Email Address"
                    className="form-control"
                />
                <input
                    type="password"
                    value={passwordOne}
                    onChange={event => this.setState(byPropKey('passwordOne', event.target.value))}
                    className="form-control"
                    placeholder="Password"
                />
                <input
                    value={passwordTwo}
                    onChange={event => this.setState(byPropKey('passwordTwo', event.target.value))}
                    type="password"
                    className="form-control"
                    placeholder="Confirm Password"
                />
                { error && <p className="text-danger">{error.message}</p> }
                <button
                    disabled={isInvalid}
                    type="submit"
                    className="btn btn-lg btn-primary btn-block big-top-margin bottom-margin"
                >
                    Sign Up
                </button>

            </form>
        );
    }
}

const SignUpLink = () =>
    <p>
        Don't have an account?
        {' '}
        <Link className="text-primary" to={'/signup'}>Sign Up</Link>
    </p>;

export default withRouter(SignUpPage);

export {
    SignUpForm,
    SignUpLink,
};


// WEBPACK FOOTER //
// ./src/components/auth/SignUp.js